<template>
  <div class="scroll-container" >
    <div class="content" ref="scrollContainer" @scroll="handleScroll">
      <slot></slot>
    </div>
    <!-- Scroll up button -->
    <button v-if="canScrollUp" class="arrow up" @click="scrollUp"><i class="fas fa-chevron-up"></i></button>
    <!-- Scroll down button -->
    <button v-if="canScrollDown" class="arrow down" @click="scrollDown"><i class="fas fa-chevron-down"></i></button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    options: {
      type: Array
    }
  },
  data () : { canScrollUp: boolean, canScrollDown: boolean } {
    return {
      canScrollUp: false,
      canScrollDown: false
    }
  },
  watch: {
    options () {
      this.handleScroll()
    }
  },
  methods: {
    handleScroll (): void {
      this.$nextTick(() => {
        const scrollContainer = this.$refs.scrollContainer as HTMLElement
        if (!scrollContainer) return
        this.canScrollUp = scrollContainer.scrollTop > 0
        this.canScrollDown = scrollContainer.scrollTop + scrollContainer.clientHeight < scrollContainer.scrollHeight
      })
    },
    scrollUp (): void {
      const scrollContainer = this.$refs.scrollContainer as HTMLElement
      if (!scrollContainer) return
      scrollContainer.scrollBy({
        top: -200,
        behavior: 'smooth'
      })
    },
    scrollDown () : void {
      const scrollContainer = this.$refs.scrollContainer as HTMLElement
      if (!scrollContainer) return
      scrollContainer.scrollBy({
        top: 200,
        behavior: 'smooth'
      })
    }
  },
  mounted () : void {
    this.handleScroll()
  }
})
</script>

<style lang="scss" scoped>
.scroll-container {
  position: relative;
  height: 100%;
  overflow-y: hidden;
}

.content {
  overflow-y: auto;
  height: 100%;
  width: 100%;
  max-width: 320px;
  padding: 0 16px;
  margin: 0 auto;
}

.arrow {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 50%;
  font-size: 1rem;
  color: var(--hover-selected-text-color);
  background: var(--hover-selected-background-color);
  opacity: 0.8;
  cursor: pointer;
  transition: transform 0.3s ease;
  animation: bounce 1s infinite;
}

.arrow.up {
  top: 0px;
}

.arrow.down {
  bottom: -8px;
}

@keyframes bounce {
  0%, 100% {
    transform: translateX(-50%) translateY(0);
  }
  50% {
    transform: translateX(-50%) translateY(-5px);
  }
}

// Dark mode
@media (prefers-color-scheme: dark) {
  .dark-theme {
    .arrow {
      color: var(--dark-blue);
      background: var(--white);
    }
  }
}

// Desktop
@media (min-width: 700px) {
  .arrow {
    display: none;
  }
}
</style>
